import {Directive, Input} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";

@Directive({
    selector: '[nonEmptyList]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NonEmptyListValidatorDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class NonEmptyListValidatorDirective implements Validator {
    @Input('nonEmptyList') nonEmptyList : boolean | string;

    validate(control: AbstractControl): ValidationErrors | null {
        return control.value == null
            ? {
                nonEmptyList: "empty"
            }
            : null;
    }
}